import {
    CHANGE_LANGUAGE
} from "../../helper/constants";
import {getPrefLang, isPrefLangPresent} from "../actions/prefs";


const initialState = {
    lng: isPrefLangPresent() ? getPrefLang() : "en",
};

export default function (state = initialState, action) {
    switch (action.type) {
        case CHANGE_LANGUAGE: {
            return Object.assign({}, state, {
                ...state,
                lng: action.payload,
            });
        }
        default:
            return state;
    }
}